// extracted by mini-css-extract-plugin
export default {"patientDetails":"PatientFiles_patientDetails__pHFKN"};